import React from "react";
import { useSelector } from "react-redux";
import BotActivityTile from "./BotActivityComponent/BotActivityTile"
import { store } from "../../Redux/store";
import api from "../../veracityapi";
import "./BotActivity.scss";


const Protection = () => {

	console.log("BotActivity Rendered");
	const loadingState = useSelector(store => store?.loadData?.data);
	const sidetoggle = useSelector(state => (state.toggle.toggle));
	const [loading, setLoading] = React.useState(loadingState);
	const graphsHeading = store.getState().websiteDetails?.data?.websiteDetails?.status === "protect" ? "Blocked" : "Detected";
	const licenceDetails = useSelector(state => state?.websiteDetails?.data?.licenceKeys[0]);
	const customerPackages = useSelector(state => state?.websiteDetails?.data?.customerPackages);
	const currentPackage = customerPackages?.find((val) => val.current === 1);
	const lastTraffic = useSelector((state) => state?.websiteDetails?.data?.websiteDetails);
	if (!api.isUserLoggedIn() || api.getCustomerGUID() === null || api.getWebsiteGUID() === null) {
		api.logout("Fatal Error")
	};

	React.useEffect(() => {
		setLoading(loadingState)
	}, [loadingState])
	React.useLayoutEffect(() => {
		document.body.style.backgroundColor = "rgba(244, 244, 244, 1)"
	}, []);

	const Iframe = () => {
		if (currentPackage?.custom === 1) {
			return (
				<iframe style={
					{
						width: "100%",
						height: "100vh",
						border: "none"
					}
				}
					src="https://go.veracitytrustnetwork.com/no-wtp-data-direct/"
					title="Finish Setup" />
			);
		}
		return (
			<iframe style={
				{
					width: "100%",
					height: "90vh",
					border: "none"
				}
			}
				src="https://go.veracitytrustnetwork.com/no-wtp-data-new/"
				title="Finish Setup" />
		);
	};

	const renderDisplay = () => {
		const now = Date.now() ;
		const hours24Ago = new Date(now - 86400000);
		const hours24After = new Date(now + 86400000);
		const startDate = new Date(licenceDetails.start_date);
		return (
			( startDate > hours24Ago ?
				<div className={`display-area ${sidetoggle ? "display-area--small" : "display-area--large"}`}>
					<h1>There is no historical data available yet.</h1>
					<span>This will be available from {hours24After.toLocaleDateString()}</span>
				</div>
				:
				<div className={`display-area ${sidetoggle ? "display-area--small" : "display-area--large"}`}>
					<BotActivityTile graph='Bot Threat' loading={loading} setLoading={setLoading} />
					<BotActivityTile graph="Finished Sessions" loading={loading} setLoading={setLoading} />
					<BotActivityTile graph='Good Bots and CO2' loading={loading} setLoading={setLoading} />
					<BotActivityTile graph='Bot Sources' loading={loading} setLoading={setLoading} />
				</div>
			)
		);
	}

	return (

		<div className="analytics-container">
			{
				lastTraffic?.last_traffic == null ?
					(<>
						<Iframe />
					</>) :
					renderDisplay()
			}

		</div>
	)
};

export default Protection;
